var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-widget"},[(_vm.$checkPermission('voting'))?_c('div',{staticClass:"tab-item",class:{ active: _vm.activeTab == 'management' },on:{"click":function($event){return _vm.switchTab('management')}}},[_vm._v(" DONATION MANAGMENT ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }